const PlatformRequest = typeof Request != "undefined" ? Request : globalThis.Request;
const PlatformResponse = typeof Response != "undefined" ? Response : globalThis.Response;
export { PlatformRequest as Request, PlatformResponse as Response };
//# sourceMappingURL=Platform.js.map